import { IComponentOptions } from 'angular';
import template from './progress-widget.html';
import controller from './progress-widget.controller';

// import './gauge-chart-widget.scss';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
